export enum AIChatDisplayType {
  POPUP = 'popup',
  PAGE = 'page'
}
